import { useNavigate } from 'react-router-dom'
import { Home, ArrowLeft, SearchX } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

export function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-lg shadow-lg border-border/50">
        <CardContent className="flex flex-col items-center text-center space-y-6 pt-10 pb-10">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-destructive/10">
            <SearchX className="h-10 w-10 text-destructive" />
          </div>
          <div className="space-y-2">
            <h1 className="text-7xl font-extrabold text-primary tracking-tight">404</h1>
            <h2 className="text-2xl font-semibold text-foreground">
              Page introuvable
            </h2>
            <p className="text-muted-foreground max-w-sm mx-auto">
              La page que vous recherchez n'existe pas ou a été déplacée.
              Vérifiez l'URL ou retournez au tableau de bord.
            </p>
          </div>
          <div className="flex items-center justify-center gap-3 pt-2">
            <Button variant="outline" onClick={() => navigate(-1)}>
              <ArrowLeft className="mr-2 h-4 w-4" />
              Retour
            </Button>
            <Button onClick={() => navigate('/dashboard')}>
              <Home className="mr-2 h-4 w-4" />
              Tableau de bord
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
